import { useMsal } from "@azure/msal-react";
import { Navigate, Outlet } from "react-router-dom";
import Navbar from "../components/Navbar";

const ProtectedRoutesWrapper: React.FC = () => {
    const { accounts } = useMsal(); // Check if the user is authenticated

    return accounts.length > 0 ? (
        <>
            <Navbar />
            <Outlet />
        </>
    ) : (
        <Navigate to="/" />
    );
};

export default ProtectedRoutesWrapper;